{
  "page_404": {
    "title": "404 Página no encontrada",
    "heading": "¡Lo sentimos, página no encontrada!",
    "description": "Lo sentimos, no pudimos encontrar la página que estás buscando. ¿Quizás has escrito mal la URL? Asegúrate de revisar la ortografía.",
    "go_home": "Ir a Inicio"
  }
}
